import AttachmentModel from "./AttachmentModel";
export default class ProgressTicketModel {
  id: string | null;
  ticket_id: string | null;
  desc: string | null;
  subject: string | null;
  upload_by: string | null;
  user_approval_status: string | null;
  supervisor_approval_status: string | null;
  progress_status: string | null;
  user_approval_message: string | null;
  supervisor_approval_message: string | null;
  attachment: AttachmentModel[];
  deleted_at: string | null;
  created_at: string | null;
  updated_at: string | null;
  constructor() {
    this.id = null;
    this.ticket_id = null;
    this.desc = null;
    this.subject = null;
    this.upload_by = null;
    this.user_approval_status = null;
    this.supervisor_approval_status = null;
    this.progress_status = null;
    this.user_approval_message = null;
    this.supervisor_approval_message = null;
    this.attachment = [];
    this.deleted_at = null;
    this.created_at = null;
    this.updated_at = null;
  }
}
